export const CONFERENCE_INFO = {
    // alwaysVisible: [ 'raised-hands-count', 'recording', 'subject' ],
    alwaysVisible: ['subject'],
    autoHide: [
        'highlight-moment',
        'conference-timer',
        'participants-count',
        'e2ee',
        'transcribing',
        'video-quality',
        'visitors-count',
        'insecure-room',
        'top-panel-toggle'
    ]
};
